import React from 'react';
import './App.scss';
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
// import Home from './components/Home';
import Iframe from './components/Iframe';
import Footer from './components/Footer';
import Login from './components/Login';
import PageNotFound from './components/PageNotFound';
import Menu from './components/Menu';
import PrivateRoute from './components/PrivateRoute';
import EnvironmentTag from './components/EnvironmentTag';
import APIRedoc from './components/APIRedoc';

function App() {

  const { pathname } = useLocation();

  return (
    <>
      <EnvironmentTag />
      <Menu />
      <div id="content-container">
        <Switch>
          {/* <Route path="/" exact component={Home} /> */}
          <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
          <PrivateRoute path="/docs/graphql/assets" exact component={Iframe} src="/docs/graphdoc/assets/index.html" />
          <PrivateRoute path="/docs/graphql/monolith" exact component={Iframe} src="/docs/graphdoc/monolith/index.html" />
          {/* <PrivateRoute path="/docs" exact component={Iframe} src="/redoc/index.html" /> */}
          <PrivateRoute path="/docs" exact component={APIRedoc} />
          <Route path="/login" component={Login} exact />
          <Redirect from="/" to="/docs" />
          <Route component={PageNotFound} />
        </Switch>
      </div>
      <Footer />
    </>
  );
}

export default App;
